import { useEffect, useRef } from 'react'

export const useScrollInteractionHandler = ({
  containerRef,
  sectionRef,
  onGoBack,
  onEnter,
}: {
  containerRef: React.RefObject<HTMLDivElement>
  sectionRef: React.RefObject<HTMLElement>
  onGoBack: () => void
  onEnter: () => void
}) => {
  const prevTop = useRef<number | null>(null)
  const isEntered = useRef(false)

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current || !sectionRef.current) return

      const rect = sectionRef.current.getBoundingClientRect()
      const containerHeight = containerRef.current.clientHeight
      const isTargetGoingDown = prevTop.current !== null && prevTop.current < rect.top
      const isTargetGoingUp = prevTop.current !== null && prevTop.current > rect.top

      if (isTargetGoingDown && rect.top >= containerHeight && isEntered.current) {
        onGoBack()
        isEntered.current = false
      }
      if (isTargetGoingUp && rect.top < containerHeight && !isEntered.current) {
        onEnter()
        isEntered.current = true
      }

      prevTop.current = rect.top
    }

    containerRef.current?.addEventListener('scroll', handleScroll, { passive: true })
    return () => containerRef.current?.removeEventListener('scroll', handleScroll)
  }, [containerRef, sectionRef, onGoBack, onEnter])

  return null
}
